import { Box, Text, useForceUpdate } from '@chakra-ui/react';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import { Interval } from './utils/Interval';

export interface IMessageProps {
    message: string;
    timestamp: string;
    type: string;
    longTime: boolean;
}

export function Message(props: IMessageProps) {
    const update = useForceUpdate();

    if (props.type === 'server') {
        return (
            <Box
                borderColor="blue.400"
                borderWidth={1}
                borderRadius="md"
                background="blue.600"
                px={6}
                py={4}
                mr={16}
                mt={props.longTime ? 8 : undefined}
            >
                <Text fontSize="sm" color="blue.200" mb={2}>
                    <Interval interval={1000} update={() => update()}>
                        {() => (
                            <>
                                {moment(props.timestamp).fromNow()} (
                                {moment(props.timestamp).format('H:mm:ss DD. MM. YYYY')})
                            </>
                        )}
                    </Interval>
                </Text>
                <ReactMarkdown>{props.message}</ReactMarkdown>
            </Box>
        );
    }

    if (props.type === 'client') {
        return (
            <Box
                borderColor="gray.600"
                borderWidth={1}
                borderRadius="md"
                background="gray.800"
                px={6}
                py={4}
                ml={16}
                mb={props.longTime ? 8 : undefined}
            >
                <Text fontSize="sm" color="gray.500" mb={2}>
                    <Interval interval={1000} update={() => update()}>
                        {() => (
                            <>
                                {moment(props.timestamp).fromNow()} (
                                {moment(props.timestamp).format('H:mm:ss DD. MM. YYYY')})
                            </>
                        )}
                    </Interval>
                </Text>
                <ReactMarkdown>{props.message}</ReactMarkdown>
            </Box>
        );
    }

    if (props.type === 'admin') {
        return (
            <Box
                borderColor="orange.400"
                borderWidth={1}
                borderRadius="md"
                background="orange.700"
                px={6}
                py={4}
                mr={16}
                mt={props.longTime ? 8 : undefined}
            >
                <Text fontSize="sm" color="orange.200" mb={2}>
                    <Interval interval={1000} update={() => update()}>
                        {() => (
                            <>
                                {moment(props.timestamp).fromNow()} (
                                {moment(props.timestamp).format('H:mm:ss DD. MM. YYYY')})
                            </>
                        )}
                    </Interval>
                </Text>
                <ReactMarkdown>{props.message}</ReactMarkdown>
            </Box>
        );
    }

    return <></>;
}
